import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BookingService } from '../../../services/Booking/booking.service';
import { f } from "../../../../../node_modules/@angular/material/icon-module.d-COXCrhrh";
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MomentFormatPipe } from "../../../moment.pipe";
import { YesNoPipe } from "../../../pipes/yes-no.pipe";
import { AuthService } from '../../../services/Auth/auth.service';

@Component({
    selector: 'app-dashboard-delete-overlay',
    imports: [
        CommonModule,
        RouterModule,
        MatIconModule,
        MatSnackBarModule,
        MomentFormatPipe,
        YesNoPipe
    ],
    templateUrl: './dashboard-delete-overlay.component.html',
    styleUrl: './dashboard-delete-overlay.component.scss'
})
export class DashboardDeleteOverlayComponent {
    constructor(
        public authService: AuthService,
        private snackBar: MatSnackBar,
    ) {

    }

    close() {
        this.authService.closeDeleteOverlay()
    }

    confirm() {
        this.authService.executeDeleteProfile()
    }
}
